import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'test',
      type: 'tree-editor',
      content: {
        '{}': {
          displayBindings: {
            '{}': {
              label: {
                '{}': {
                  attr: '!name',
                  source: 'value-string',
                },
              },
              sublabel: {
                '{}': {
                  attr: '!org',
                  source: 'reference-breadcrumb',
                },
              },
              title: {
                '{}': {
                  attr: '!job_title',
                  source: 'reference-breadcrumb',
                },
              },
            },
          },
          nodes: {
            '@': 'outcomes',
          },
          edgesFrom: {
            '{}': {
              child: '!personnel',
              parent: '!leader',
              association: 'ent:!personnel_leaders:!relationship',
            },
          },
        },
      },
    },
  },
  subqueries: {
    outcomes: {
      target: 'dim::!personnel',
      selection: {
        '{}': {
          label: {
            '@.': '!name',
          },
          sublabel: {
            '@': 'organizationName',
          },
          title: {
            '@': 'jobTitle',
          },
          values: {
            '@.*': {},
          },
          modelId: {
            '@_': 'id',
          },
          peopleInsights: {
            '`': {
              filter: {
                '=': [
                  {
                    '@.': '!id',
                  },
                  {
                    '``': {
                      '@.': '!id',
                    },
                  },
                ],
              },
              target: 'ent:!personnel:!employee',
              selection: {
                '{}': {
                  skills: {
                    '@': 'skills',
                  },
                  availability: {
                    '{}': {
                      currentMonthHours: {
                        '??': [
                          {
                            '-': [
                              40,
                              {
                                '+': {
                                  '@': 'currentAvailability',
                                },
                              },
                            ],
                          },
                          40,
                        ],
                      },
                    },
                  },
                  projectEngagements: {
                    '@': 'engagements',
                  },
                },
              },
              subqueries: {
                skills: {
                  ref: {
                    attr: 'attr:ent#!employee_skills#!entry:!skill',
                  },
                  using: 'skillEntry',
                  target: 'ent:!skills:!skill',
                  selection: {
                    '{}': {
                      name: {
                        '@.': '!name',
                      },
                      hasCertification: true,
                    },
                  },
                },
                skillEntry: {
                  ref: {
                    attr: 'attr:ent#!employee_skills#!entry:!employee',
                  },
                  target: 'ent:!employee_skills:!entry',
                },
                engagements: {
                  ref: {
                    attr: 'attr:ent#!engagements#!engagement:!employee',
                  },
                  target: 'ent:!engagements:!engagement',
                  selection: {
                    '{}': {
                      role: {
                        '@.': '!role',
                      },
                      period: {
                        '@.': '!active_periods',
                      },
                      description: {
                        '@.': '!descr',
                      },
                      projectName: {
                        '@': 'project',
                      },
                    },
                  },
                  subqueries: {
                    project: {
                      ref: {
                        attr: 'attr:ent#!engagements#!engagement:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!name',
                      },
                    },
                  },
                },
                currentAvailability: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  using: 'engagements',
                  filter: {
                    '=': [
                      {
                        '@.': '!is_current',
                      },
                      true,
                    ],
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
              },
            },
          },
        },
      },
      subqueries: {
        organizationName: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!org',
          },
          quantity: 1,
          target: 'dim::!org',
          selection: {
            '@.': '!name',
          },
        },
        jobTitle: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!job_title',
          },
          quantity: 1,
          target: 'ent:!job_titles:!job_title',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
  },
}
